import DataModel from "../../model-factory/basic/data/DataModel";
import {IPopulateIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {SearchPageBasicDataModel} from "./SearchPageBasicDataFactory";
import ApiRequestVO from "../../manager/api/ApiRequestVO";
import {IAnyObject} from "../../common/SimpleInterface";
import {isNumeric} from "../../common/SiteHelper";

export class SearchParams
{
    sortBy:string = "";
    sortDesc:boolean = false;
    searchTermID:string = "";
    searchTerm:string = "";

    applyModelConditions(populateIDs: IPopulateIDs)
    {
        this.sortBy = populateIDs.search_sort_by ?? this.sortBy;
        this.sortDesc = populateIDs.search_sort_desc ?? this.sortDesc;
        this.searchTermID = populateIDs.search_term_id ?? ""
        this.searchTerm = this.searchTermID && this.searchTermID !== "search_all" ? decodeURIComponent(this.searchTermID) : "";
    }
}

export class SearchBasicDataModel extends DataModel
{
    searchParams:SearchParams = new SearchParams();

    pageNumber:number = 1;

    applyModelConditions()
    {
        super.applyModelConditions();

        this.searchParams.applyModelConditions(this.populateIDs)
    }

    addPageParamsToRequest(requestVO:ApiRequestVO)
    {

        const pageModel = this.getPageModel();
        if(pageModel){
            requestVO.params.limit = pageModel.entryLimit
            requestVO.params.page = this.pageNumber
            requestVO.params.include_previous_next_ids = true
        }
    }


    getPageChildModels(): SearchBasicDataModel[]
    {
        return [];
    }

    getPageModel(): SearchPageBasicDataModel|null
    {
        if(!this.pageNumber){
            return null;
        }
        return null;
    }

    applyResponseToRelatedPages = (response: IAnyObject) => {

        const searchModels = this.getPageChildModels();
        if(!searchModels.length){
            return;
        }

        let previous = this.pageNumber > 1 ? (response.previous ?? "") + "" : "";
        let next = (response.next ?? "") + "";

        previous = isNumeric(previous) && !parseInt(previous) ? "" : previous;
        next = isNumeric(next) && !parseInt(next) ? "" : next;

        let valid = (!next && (this.pageNumber === searchModels.length)) || (next && (this.pageNumber < searchModels.length));
        if(valid){
            for(let i = 0; i < searchModels.length; i++)
            {
                const searchModel = searchModels[i];
                if((searchModel.pageNumber === this.pageNumber) || !searchModel.isPopulated())
                {
                    continue;
                }
                if(searchModel.pageNumber === (this.pageNumber - 1)){
                    const lastChoiceID = searchModel.choiceOrder[searchModel.choiceOrder.length - 1] ?? "";
                    if(lastChoiceID !== previous){
                        valid = false;
                        break;
                    }
                }
                if(searchModel.pageNumber === (this.pageNumber + 1)){
                    const firstChoiceID = searchModel.choiceOrder[0] ?? "";
                    if(firstChoiceID !== next){
                        valid = false;
                        break;
                    }
                }
                for(let j = 0; j < searchModel.choiceOrder.length; j++){
                    if(this.choiceOrder.includes(searchModel.choiceOrder[i])){
                        valid = false;
                        break;
                    }
                }
                if(!valid){
                    break;
                }
            }
        }


        if(!valid){
            this.getPageModel()?.resetPopulated();
            for(let i = 0; i < searchModels.length; i++)
            {
                const searchModel = searchModels[i];
                if((searchModel.pageNumber === this.pageNumber))
                {
                    continue;
                }
                searchModel.resetPopulated();
            }
        }
    }
}